/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */

/**
 * Helpers to format string
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @version 1.16.0
 * @since 1.0.1
 */
import split from 'lodash/split';

export function stringFormat(str: string, ...args: any[]) {
    let strReturn = str;
    args.forEach((arg: any, index: number) =>
        strReturn = strReturn.replace(new RegExp('\\{' + index.toString() + '\\}', 'g'), arg));
    return strReturn;
}

export function stringFormatParams(str = '', params: any = {}) {
    let strReturn = str;
    Object.keys(params).forEach((arg: any) =>
        strReturn = strReturn.replace(new RegExp('\\{' + arg + '\\}', 'g'), params[arg]));
    return strReturn;
}

export function stringFormatParamsHtml(str = '', params: { [key: string]: JSX.Element }) {
    return split(str, /{(.*?)}+/g).reduce((elementList: any[], element) => {
        elementList.push(params[element] || element);
        elementList.push(' ');
        return elementList;
    }, []);
}

export function stringCapitalizeFirstLetter(str: string) {
    if (!str) {
        return '';
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
}
